import React from "react";
import { useTranslation } from "../../i18n";

const NoAccess: React.FC = () => {
  const t = useTranslation();

  return <div>{t("noAccess.project")}</div>;
};

export default NoAccess;
